module.exports = __webpack_public_path__ + "img/ctrl-canonical-stub-mid--.ede66fef.svg";